<template>
  <v-data-table
    :items="servers"
    :headers="headers"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50, -1]
    }"
    :search="search"
    :options.sync="options"
    item-key="Name"
    class="elevation-1"
  >
    <template v-for="(col, i) in filters" v-slot:[`header.${i}`]="{ header }">
      <div style="display: inline-block; padding: 16px 0;">{{ header.text }}</div>
      <div style="float: right; margin-top: 8px">
        <v-menu :close-on-content-click="false" :nudge-width="200" offset-y transition="slide-y-transition" left fixed style="position: absolute; right: 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="indigo" icon v-bind="attrs" v-on="on">
              <v-icon small 
                :color="activeFilters[header.value] && activeFilters[header.value].length < filters[header.value].length ? 'red' : 'default'">
                mdi-filter-variant
              </v-icon>
            </v-btn>
          </template>
          <v-list flat dense class="pa-0">
            <v-list-item-group multiple v-model="activeFilters[header.value]" class="py-2">
              <template v-for="(item, i) in filters[header.value]">
                <v-list-item :key="`${item}`" :value="item" :ripple="false">
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action>
                      <v-checkbox :input-value="active" :true-value="item"
                        color="primary" :ripple="false" dense></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content> 
                      <v-list-item-title v-text="item"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
            <v-divider></v-divider>
            <v-row no-gutters>
              <v-col cols="6">
                <v-btn text block @click="toggleAll(header.value)" color="success">Toggle all</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn text block @click="clearAll(header.value)" color="warning">Clear all</v-btn>
              </v-col>
            </v-row>
          </v-list>
        </v-menu>
      </div>
    </template>
    <template v-slot:top>
      <v-row>
        <v-col
          class="col-12"
        >
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          />
        </v-col>
      </v-row>
    </template>
    <template
      v-slot:item.last_modified_date="{ item }"
    >
      {{ getUTCString(item.last_modified_date) }}
    </template>
    <template
      v-slot:item.monitor_assyst="{ value }"
    >
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template
      v-slot:item.monitor_ping="{ value }"
    >
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template
      v-slot:item.monitor_search="{ value }"
    >
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template
      v-slot:item.monitor_chat="{ value }"
    >
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template
      v-slot:item.monitor_reports="{ value }"
    >
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template
      v-slot:item.monitor_activemq="{ value }"
    >
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template
      v-slot:item.monitor_ipaas="{ value }"
    >
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.Name="{ item }">
      <router-link
        :to="`/contracts/${item.contract.contract_id}`"
        class="text-decoration-none"
      >
        {{ item.Name }}
      </router-link>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: 'PausedServerAlertsTable',
    props: {
      servers: Array,
      type: String
    },
    data () {
      return {
        options: {
          itemsPerPage: 20,
          sortBy: ['Name'],
        },
        search: '',
        filters: { 'contract.status': [ 'Live Status', 'Migrating', 'Proof of Concept', 'On-boarding' ] },
        activeFilters: { 'contract.status': [ 'Live Status' ]},
      }
    },
    computed: {
      headers () {
        var tempArray = []
        tempArray.push(
          { value: 'Name', text: 'Name', width: '20%'},
          {
            value: 'contract.status',
            text: 'Status',
            sortable: true,
            filter: value => {
              return this.activeFilters['contract.status'] ? this.activeFilters['contract.status'].includes(value) : true
            },
          },
        )
        if (this.type === 'web') {
          tempArray.push(
            { value: 'monitor_assyst', text: 'Assyst' }
          )
        }
        if (this.type === 'csr') {
          tempArray.push(
            { value: 'monitor_search', text: 'Search' },
            { value: 'monitor_reports', text: 'Reports' },
            { value: 'monitor_chat', text: 'Chat' }
          )
        }
        if (this.type === 'imq') {
          tempArray.push(
            { value: 'monitor_ipaas', text: 'IPaaS' },
            { value: 'monitor_activemq', text: 'ActiveMQ' }
          )
        }
        tempArray.push(
          { value: 'monitor_ping', text: 'Ping' },
          { value: 'last_modified_by_user.user_name', text: 'User' },
          { value: 'last_modified_date', text: 'Paused' }
        )

        return tempArray
      }
    },
    methods: {
      getUTCString: function (datetime) {
        const d = new Date(datetime)
        return d.toUTCString()
      },
      // The filters on this table are very 'hacky' and essentially hard-coded rather than populated from the data itself
      // This only works because we only need to filter by the one 'Status' column
      toggleAll (col) {
        this.activeFilters[col] = [ 'Live Status', 'Migrating', 'Proof of Concept', 'On-boarding' ]
      },
      clearAll (col) {
        this.activeFilters[col] = []
      },
      displayIcon: function(item) {
        if (item === 'y') {
          return 'mdi-check'
        } else {
          return 'mdi-close'
        }
      },
      iconColour: function(item) {
        if (item === 'y') {
          return 'success'
        } else {
          return 'error'
        }
      }
    },
  }
</script>
